import { useAccountsStore } from '../../store'
import Home from './home.vue'
import Welcome from './views/welcome.vue'
import MyAccount from './views/my-account.vue'
import administration from '../administration'

/**
 * Account area: a layout with the navigation menu and nested views, each with its own URL.
 * All routes of the applet are namespaced under `/accounts`. The views in `views` are for every
 * account, those in `routes/administration` for administrators only.
 */
export default {
  name: 'accounts',
  path: '/accounts',
  component: Home,
  meta: {
    secure: true
  },
  // The bare `/accounts` path leads to the welcome page: administrators get the one with the statistics
  redirect: () => {
    const { account } = useAccountsStore()
    return { name: account?.isAdministrator ? 'accounts-summary' : 'accounts-home' }
  },
  children: [
    {
      name: 'accounts-home',
      path: 'welcome',
      component: Welcome
    },
    {
      name: 'my-account',
      path: 'my-account',
      component: MyAccount
    },
    ...administration
  ]
}
